import { Routes } from '@angular/router';
import { ErrorPageComponent } from 'src/auth/pages/404/error-page.component';
import { AuthGuard } from '../app/guards/auth.guard';

export const mainRoutes: Routes = [
    {
        path: 'home',
        loadComponent: () => import('../auth/pages/home-page/home-page.component').then((c) => c.HomePageComponent)
    },
    {
        path: '',
        loadChildren: () => import('./app-shell/app-shell.routes').then((r) => r.appShellRoutes),
        canActivate: [AuthGuard]
    },
    {
        path: '**',
        pathMatch: 'full',
        component: ErrorPageComponent
    }
];
